<div id="success-msg-container" fxLayout="row" fxLayoutAlign="center center">
  <mat-card class="example-container" fxFlex="30%" fxFlex.lt-md="65%" fxFlex.lt-sm="95%">
    <mat-card-content>
      <span class="header">{{pageName}}</span>
      <div class="tick">
        <img class="width" [src]="imglist.tick" alt="Successfull">
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-flat-button type="button" (click)="goLogin()" color="primary">{{'Go to Login Page'}}</button>
    </mat-card-actions>
  </mat-card>
</div>